<template>
  <div class="scroll-to-top-btn-container" @click="scrollToTop">
    <Icons name="arrow" :rotate="90" style="--icon-size: 18px" />
    <span>{{ scrollToTopText }}</span>
  </div>
</template>

<script>
import Icons from '@sephora-asia/atoms-icons/Icons.vue'
import i18n from '../mixins/i18n'

export default {
  name: 'ScrollToTopButton',
  components: {
    Icons
  },
  mixins: [i18n],

  props: {
    filterTypes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      fixedFilters: ['min-price', 'max-price', 'brands', 'others']
    }
  },

  computed: {
    currentFilters() {
      const dynamicFilters = this.filterTypes.map((filter) => filter.slugUrl)
      return [...this.fixedFilters, ...dynamicFilters]
    },

    scrollToTopText() {
      const isFilterIncluded = (key) => this.currentFilters.includes(key)

      return Object.keys({ ...this.$route?.query }).some(isFilterIncluded)
        ? this.$t('products.filters.scrollToTopButton.filtered')
        : this.$t('products.filters.scrollToTopButton.unfiltered')
    }
  },

  methods: {
    scrollToTop() {
      globalThis.scrollTo?.({
        top: 0,
        behavior: 'smooth' // smooth doesn't work for safari
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-to-top-btn-container {
  display: flex;
  position: sticky;
  top: 80px; // height of top-nav-bar & nav-container
  padding: 40px 55px;
  cursor: pointer;

  ::v-deep .icon-container {
    margin: 5px 8px;
  }

  &:hover {
    color: $red;

    ::v-deep svg {
      fill: $red;
    }
  }
}
</style>
